<automata-closing-side-drawer [title]="title">
  <automata-side-drawer-pre-title-actions *ngIf="showBackButton" class="back-button">
    <button mat-icon-button color="primary" (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </automata-side-drawer-pre-title-actions>

  <automata-side-drawer-content>
    <ng-container *ngIf="showDebugInfo$ | async">
      <mat-accordion displayMode="flat" *ngIf="{ value: inputParameters$ | async } as inputParametersValue">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'DEBUG.INPUT_PARAMETERS_COUNT' | translate: { count: (inputParametersValue.value || []).length } }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let inputParameter of inputParametersValue.value">
            <pre>{{ inputParameter.settings.id }} {{ inputParameter.path }}</pre>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion displayMode="flat" *ngIf="{ value: outputParameters$ | async } as outputParametersValue">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'DEBUG.OUTPUT_PARAMETERS_COUNT' | translate: { count: (outputParametersValue.value || []).length } }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let outputParameter of outputParametersValue.value">
            <pre>{{ outputParameter.settings.id }} {{ outputParameter.path }}</pre>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

    <div [hidden]="(isAvailableOnSubscriptionLevel$ | async) === false">
      <ng-container *ngIf="(isEditable$ | async) === false">
        <div class="running-disclaimer">
          <glxy-alert type="warning">
            {{ editingPreventedWarning() | async }}
          </glxy-alert>
        </div>
      </ng-container>

      <div class="app-requirements-alert" *ngIf="automationContext === context.AUTOMATION_CONTEXT_SMB">
        <automata-app-requirements-alert [requiredApps]="(taskDefinition$ | async)?.requiredApps">
        </automata-app-requirements-alert>
      </div>

      <div class="step-name-input">
        <glxy-form-field>
          @if (isGoal) {
            <glxy-label>
              {{ 'AUTOMATIONS.EDITOR.GOAL_NAME' | translate }}
            </glxy-label>
          } @else {
            <glxy-label>
              {{ 'AUTOMATIONS.EDITOR.STEP_ID' | translate }}
            </glxy-label>
          }
          <input type="text" matInput [formControl]="stepIdentifierControl" />
          <glxy-error *ngIf="stepIdentifierControl.hasError('maxlength')">
            {{ 'AUTOMATIONS.EDITOR.STEP_ID_MAX_LENGTH' | translate }}
          </glxy-error>
        </glxy-form-field>
      </div>
      <automata-task-error-disclaimer [stepId]="step?.id"></automata-task-error-disclaimer>
      <!-- THIS IS WHERE THE SPECIFIC ACTION PANEL GETS INJECTED INTO THE SIDEBAR !-->
      <ng-template automataDynamicComponent></ng-template>
      <div *ngIf="supportsCustomOutputParameters" class="content">
        <automata-custom-output-parameters
          [step]="step"
          [descriptionText]="'AUTOMATIONS.EDITOR.RETURN_VALUES.RETURN_VALUES_DESCRIPTION'"
          [sectionTitleText]="'AUTOMATIONS.EDITOR.RETURN_VALUES.RESPONSE_BODY'"
          #customOutputParameters
        ></automata-custom-output-parameters>
      </div>
      <div class="divider-padding">
        <mat-divider></mat-divider>
      </div>
      <form [formGroup]="form" class="content" *ngIf="showDataPassing">
        <glxy-form-field>
          <glxy-label>{{ 'AUTOMATIONS.EDITOR.NOTES' | translate }}</glxy-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="8"
            [formControl]="stepNotesControl"
          ></textarea>
        </glxy-form-field>
      </form>
    </div>

    <div class="content" *ngIf="(isAvailableOnSubscriptionLevel$ | async) === false">
      <div class="step-name">{{ name | translate }}</div>
      <div class="upgrade-title">{{ upgradeTitle | translate }}</div>
      <div class="upgrade-description">
        {{ upgradeDescription | translate }}
      </div>
      <button mat-flat-button color="primary" (click)="upgrade()">
        {{ 'COMMON.ACTION_LABELS.UPGRADE' | translate }}
      </button>
    </div>
  </automata-side-drawer-content>

  <automata-side-drawer-footer
    *ngIf="(isEditable$ | async) && (step || (isAvailableOnSubscriptionLevel$ | async) === true)"
  >
    <ng-container *ngIf="!isProcessing; else processing">
      <div class="footer-actions">
        <div>
          <button
            mat-stroked-button
            color="warn"
            class="delete-button"
            *ngIf="!!step"
            (click)="delete()"
            [attr.data-action]="'delete-' + (isGoal ? 'goal' : 'step')"
          >
            {{ 'COMMON.ACTION_LABELS.DELETE' | translate }}
          </button>
          <button
            mat-flat-button
            color="primary"
            *ngIf="(isAvailableOnSubscriptionLevel$ | async) === true && showNextButton"
            (click)="next()"
          >
            {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
          </button>
          <button
            mat-flat-button
            color="primary"
            *ngIf="(isAvailableOnSubscriptionLevel$ | async) === true && showSaveButton"
            (click)="save()"
            [disabled]="!savingEnabled"
            [attr.data-action]="'save-' + (isGoal ? 'goal' : 'step')"
          >
            {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #processing>
      <button mat-flat-button disabled color="primary" class="processing-message">
        <span>
          <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
        </span>
      </button>
    </ng-template>
  </automata-side-drawer-footer>
</automata-closing-side-drawer>
